import { ReactComponent as Break } from '@assets/icons/break.svg'
import { ReactComponent as Focus } from '@assets/icons/focus.svg'

const TYPES_CHIPS = {
  FOCUS: {
    icon: <Focus />,
    text: 'Foco',
    class: 'focus',
    key: 'FOCUS',
  },
  SHORT_BREAK: {
    icon: <Break />,
    text: 'Intervalo Curto',
    class: 'short-break',
    key: 'SHORT_BREAK',
  },
  LONG_BREAK: {
    icon: <Break />,
    text: 'Intervalo Longo',
    class: 'long-break',
    key: 'LONG_BREAK',
  },
}

export { TYPES_CHIPS }
